// extracted by mini-css-extract-plugin
module.exports = {"a0":"Navbar-styles-module--navbar--1GEVz","cls1":"AppBanner-module--cls1--PR-EM","cls2":"AppBanner-module--cls2--3laPc AppBanner-module--cls1--PR-EM"};